import React from 'react';
import classNames from 'classnames/bind';
import styles from './index.pcss';

const cx = classNames.bind(styles);
interface EducateCustomerPropsType {
  ctaLabel: string;
}
const EducateCustomer = (props: EducateCustomerPropsType) => {
  const { ctaLabel = '' } = props;
  return (
    <div className={cx('ril-user-educate-section')}>
      <div className={cx('ril-user-educate-text')} dangerouslySetInnerHTML={{ __html: ctaLabel }} />
    </div>
  );
};

export default EducateCustomer;
